export const css = `
    blockquote,
    dl,
    dd,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    hr,
    figure,
    p,
    pre {
      margin: 0;
    }

    p {
      font-weight: 500;
    }
  
    .flex {
      display: flex;
    }

    .flex-1 {
      flex: 1;
    }
  
    .space-between {
      justify-content: space-between;
    }
  
    .space-evenly {
      justify-content: space-evenly;
    }
  
    .flex-middle {
      align-items: center;
    }

    .align-items-end {
      align-items: flex-end;
    }

    .align-items-start {
      align-items: flex-start;
    }
  
    .text-align-center {
      text-align: center;
    }
  
    .text-align-right {
      text-align: right;
    }
  
    .text-align-left {
      text-align: left;
    }

    text-uppercase{
      text-transform: uppercase;
    }

    .fs-12{
      font-size: 12px !important;
    }

    .fs-11{
      font-size: 11px !important;
    }
  
    .mt-8 {
      margin-top: 8px;
    }
  
    .pt-4 {
      padding-top: 4px;
    }
  
    .pt-8 {
      padding-top: 8px !important;
    }

    .px-8 {
      padding-right: 8px !important;
      padding-left: 8px !important;
    }

    .pr-20 {
      padding-right: 20px;
    }

    .pr-4 {
      padding-right: 4px;
    }

    .pb-30 {
      padding-bottom: 30px;
    }

    .pb-0 { 
      padding-bottom: 0px !important;
    }
  
    .px-30 {
      padding: 30px 0;
    }
  
    .px-20 {
      padding: 20px 0;
    }

    .p-8 {
      padding: 8px !important;
    }
  
    .m-0 {
      margin: 0;
    }

    .mx-auto{
      margin: 0 auto;
    }
  
    .text-value {
      display: flex;
      min-width: 250px;
      gap: 4px
    }
  
    .font-italic {
      font-style: italic;
    }

    .fw-bold {
      font-weight: bold;
    }
  
    .lable {
      margin: 0;
      padding-top: 16px;
      margin-bottom: -2px
    }
  
    .w-5 {
      width: 5%;
    }
  
    .w-9 {
      width: 9%;
    }
  
    .w-12 {
      width: 12%;
    }
  
    .w-15 {
      width: 15%;
    }

    .w-17 {
      width: 17%;
    }

    .w-20 {
      width: 20%;
    }
  
    .w-27 {
      width: 27%;
    }
  
    .w-33 {
      width: 33%;
    }
  
    .w-48 {
      width: 48%;
    }

    .w-80 {
      width: 48%;
    }
  
    .w-100 {
      width: 100%;
    }
  
    .w-20px {
      width: 20px;
    }

    .w-30px {
      width: 30px;
    }

    .w-50px {
      width: 50px;
    }

    .w-55px {
      width: 55px !important;
    }

    .w-80px {
      width: 80px !important;
    }
  
    .w-110px {
      width: 110px;
    }
  
    .w-250px {
      width: 250px;
    }
  
    .border-none {
      border: none;
    }

    .border-top-2 {
      border-top: 2px solid black;
    }
  
    .border-table {
      border: 1px solid;
      padding: 5px;
    }
  
    .represent {
      display: flex;
      justify-content: center;
      margin: 0 12%;
    }
  
    .signature {
      display: flex;
      justify-content: space-between;
      margin: 0 7%;
      text-align: center;
    }
  
    .value {
      display: flex;
      flex: 1;
      align-items: flex-end;
      width: 100%;
      margin: 0;
      font-weight: bold;
      border-bottom: 1px dotted black;
      line-height: calc(100% - 2px);
    }
  
    .line{
      border-bottom: dashed 1px;
      margin: 10px 0;
    }
  `;